export const selectStatistics = (state) => state.statistics.data
export const selectStatisticsLoading = (state) => state.statistics.isLoading
